import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function SuccessChangedWithdrawalModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const close = () => {
    closeModal(MODALS_ID.SUCCESS_CHANGED_WITHDRAWAL)
    navigate('/personalInfo')
  }

  return (
    <Modal id={MODALS_ID.SUCCESS_CHANGED_WITHDRAWAL}>
      <Text size={16} weight={500} lineHeight={24} block={true} $textAlign="center">
        출금 계좌 변경을 완료했어요.
      </Text>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={close}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
